import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25cbf594")

_pushScopeId("data-v-25cbf594")
const _hoisted_1 = { class: "server-error" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "server-error-content" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title pc-ver" }, "Server Error"),
  /*#__PURE__*/_createVNode("h1", { class: "title sp-ver" }, "500"),
  /*#__PURE__*/_createVNode("h2", { class: "sp-ver sub-title" }, "Server Error"),
  /*#__PURE__*/_createVNode("p", null, "時間をおいて再度お試しください")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})